/* CASECLUB homepage — scroll reveal + gentle parallax.
   Self-contained, dependency-free. Safe to include once per home section
   (guarded so it only initialises a single time). */
(function () {
  if (window.__caseclubHomeInit) return;
  window.__caseclubHomeInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveal ---------------------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('.home-reveal');
    if (!els.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Gentle parallax -------------------------------------------------- */
  function initParallax() {
    if (reduceMotion) return;
    var layers = Array.prototype.slice.call(document.querySelectorAll('[data-home-parallax]'));
    if (!layers.length) return;

    var visible = [];
    var vh = window.innerHeight;
    var ticking = false;

    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var el = e.target;
        if (e.isIntersecting) {
          if (visible.indexOf(el) === -1) visible.push(el);
        } else {
          var i = visible.indexOf(el);
          if (i !== -1) visible.splice(i, 1);
        }
      });
      if (visible.length) request();
    }, { threshold: 0 });
    layers.forEach(function (l) { vio.observe(l); });

    function update() {
      ticking = false;
      for (var i = 0; i < visible.length; i++) {
        var container = visible[i];
        var img = container.querySelector('img');
        if (!img) continue;
        var rect = container.getBoundingClientRect();
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh; // -1 .. 1
        var strength = parseFloat(container.getAttribute('data-home-parallax')) || 8;
        img.style.transform = 'translate3d(0,' + (progress * strength).toFixed(2) + '%,0)';
      }
    }
    function request() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', function () { vh = window.innerHeight; request(); }, { passive: true });
    update();
  }

  function boot() { initReveal(); initParallax(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-run when sections are re-rendered in the theme editor */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', boot);
  }
})();
